import { Product } from '../../../../../shared/types/systemConfiguration/products';

export const initialValues: Product = {
    name: '',
    code: '',
    sfcCaptureUnit: '',
    sfcCaptureUnitNew: '',
    active: true,
    applyEscalations: true,
    applyPqr: true,
};
